import React, { FC, ReactNode } from 'react';
import tw, { styled } from 'twin.macro';
import { CustomCssProps } from '~/config';

export type IconItemProps = CustomCssProps & {
  colorIcon?: boolean;
  id: string;
  icon: string;
  iconAlt?: string;
  title?: string;
  description?: string;
  children?: ReactNode;
};

const IconItem: FC<IconItemProps> = ({
  colorIcon,
  id,
  icon,
  iconAlt = 'icon',
  title,
  description,
  children,
}) => {
  return (
    <div className="icon-item__container" tw="items-center gap-4" data-id={id}>
      <div className="icon-item__img_container">
        <IconImage
          colorIcon={colorIcon}
          src={icon}
          alt={iconAlt}
          className="icon-item__img"
        />
      </div>
      <div className="icon-item__content">
        <h4 className="icon-item__title">{title}</h4>
        <p className="icon-item__description">
          {children ? children : description}
        </p>
      </div>
    </div>
  );
};

export default IconItem;

const IconImage = styled.img(({ colorIcon }: { colorIcon?: boolean }) => [
  !colorIcon && tw`w-32!`,
]);
